import { render } from "./Error_Handling.vue?vue&type=template&id=60d4507a"
const script = {}

import "./Error_Handling.vue?vue&type=style&index=0&id=60d4507a&lang=css"

import exportComponent from "/opt/build/repo/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__